import { AssessmentSubtype, AssessmentType } from '@@types/api.types';
import { SurveyLayout } from '@components/layouts/survey.layout';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { useGetSurvey } from '@queries/survey.query';
import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { SurveyComponent } from './components/survey.component';

export const SurveyPage: React.FC = () => {
  const { surveyId } = useParams();
  const { data: survey } = useGetSurvey(surveyId);
  const [searchParams, setSearchParams] = useSearchParams();
  const chapterId = searchParams.get('chapterId') || undefined;

  useEffect(() => {
    if (survey && !chapterId && survey.snapshot.chapters.length > 0) {
      const firstChapterId = survey.snapshot.chapters[0].id;
      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.set('chapterId', firstChapterId);
      setSearchParams(nextSearchParams, { replace: true });
    }
  }, [survey, chapterId, searchParams, setSearchParams]);

  const isMilitaryTrl =
    survey?.assessmentType === AssessmentType.TRL && survey?.assessmentSubtype === AssessmentSubtype.MILITARY;
  const title = `${isMilitaryTrl ? 'Military TRL' : (survey?.assessmentType ?? '')} Questionnaire`.trim();

  return (
    <PageviewTracker>
      <HelmetWrapper title={title} />
      <SurveyLayout>
        <SurveyComponent />
      </SurveyLayout>
    </PageviewTracker>
  );
};
